import { Parchment } from 'quill';
import React from 'react';
import Comment from './Comment';
import Diff from './Diff';
import ReactBlockEmbed from './ReactBlockEmbed';
import Reaction from './Reaction';
import VersionChange from './VersionChange';
import FileComponent from '../file/File';

export type FileValue = {
  name: string;
  size: number;
  source: string;
};

class FileBlot extends ReactBlockEmbed<FileValue> {
  static blotName = 'file';
  static className = 'ql-file';
  static tagName = 'FIGURE';
  static supportedExtensions = new Set(['pdf']);

  constructor(
    scroll: Parchment.ScrollBlot,
    domNode: HTMLElement,
    value: FileValue,
  ) {
    super(scroll, domNode, { ...value });

    this.setState(value);
  }

  format(name: string, value: File[]) {
    if (
      name === Comment.attrName ||
      name === Reaction.attrName ||
      name === Diff.attrName ||
      name === VersionChange.attrName
    ) {
      const attributor = this.scroll.query(name, Parchment.Scope.ATTRIBUTE);
      if (attributor) {
        // @ts-expect-error
        this.attributes.attribute(attributor, value);
      }
    } else {
      super.format(name, value);
    }
  }

  formats() {
    return { ...this.attributes?.values() };
  }

  getAsAttachmentFile(): FileValue {
    return this.store.getState();
  }

  render(state: FileValue) {
    return <FileComponent {...state} />;
  }
}

export default FileBlot;
